import config from '../config';

export default () => {
    const { logoutUrl } = config;
    localStorage.removeItem('page');
    const url = `${logoutUrl}${window.location.origin}/login`;
    window.location.replace(url);
};
